import React from 'react'
import { graphql } from 'gatsby'

// Components
import RefundPolicyPage from './RefundPolicyPage'

const RefundPolicyIndex = (props) => {
  // console.log('REFUND POLICY PAGE INDEX (template)', props)
  return <RefundPolicyPage {...props} />
}

export default RefundPolicyIndex

export const refundPolicyQuery = graphql`
  query RefundPolicyQuery {
    ...SiteConfig
    prismicPage(uid: { eq: "refund-policy" }) {
      uid
      type
      data {
        title
        content {
          raw
        }
      }
    }
  }
`
